export class DiscountRuleModel {
  public name: string;

  constructor(params: DiscountRuleModel) {
    this.name = params.name;
  }

  public static fromSDK(discountRuleName: string) {
    return new DiscountRuleModel({name: discountRuleName});
  }
}
